import { createClient } from '@supabase/supabase-js'

// Unterstützung für beide Umgebungsvariablen-Präfixe (NEXT_PUBLIC_ und VITE_)
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || import.meta.env.NEXT_PUBLIC_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || import.meta.env.NEXT_PUBLIC_SUPABASE_ANON_KEY

console.log('Supabase Config:', {
  url: supabaseUrl ? '✓ Gesetzt' : '✗ Fehlt',
  key: supabaseAnonKey ? '✓ Gesetzt' : '✗ Fehlt',
  urlValue: supabaseUrl?.substring(0, 30) + '...'
})

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Supabase Umgebungsvariablen fehlen!')
  console.error('Bitte VITE_SUPABASE_URL und VITE_SUPABASE_ANON_KEY in .env.local setzen.')
}

export const supabase = createClient(
  supabaseUrl || 'https://your-project.supabase.co',
  supabaseAnonKey || 'your-anon-key'
)
